import confirmReviewIcon from "assets/icons/ld-confirm-review-icon.png";

import styles from "./confirmReview.module.css";
import { useLessonPage } from "../../contexts/LessonPagesProvider/LessonPagesProvider";
import { useContext } from "react";
import { PageContext } from "../../routes/builderContexts";

export default function ConfirmReview() {
  const { pageManifest, updateManifest } = useLessonPage();
  const { updatePageManifest } = useContext(PageContext);

  if (!pageManifest?.replacedAssets?.length) {
    return null;
  }

  return (
    <div className="pageEditorActionListerRow">
      <button
        className={styles.confirmReview}
        data-tooltip-id="Confirm Review"
        onClick={() => {
          // Update both state systems to keep them in sync
          updateManifest({ replacedAssets: null });

          // Also update builder's local state for immediate UI updates
          const updatedManifest = { ...pageManifest, replacedAssets: null };
          updatePageManifest(updatedManifest);
        }}
        name="Confirm Review"
      >
        <img src={confirmReviewIcon} alt="" />
        <span>Confirm Review</span>
      </button>
    </div>
  );
}
